(function () {
  var drawer = document.getElementById('menu-drawer');
  if (!drawer) return;
  var openers = document.querySelectorAll('[data-drawer-open]');
  var closers = drawer.querySelectorAll('[data-drawer-close]');

  function open() {
    if (typeof drawer.showModal === 'function') drawer.showModal();
    else drawer.setAttribute('open', '');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function close() {
    if (typeof drawer.close === 'function') drawer.close();
    else drawer.removeAttribute('open');
  }

  openers.forEach(function (b) { b.addEventListener('click', open); });
  closers.forEach(function (b) { b.addEventListener('click', close); });
  drawer.addEventListener('close', function () {
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  });
  // Close when clicking the backdrop
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer) close();
  });
  // Close after following an in-page link (e.g. #quote)
  drawer.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', close);
  });
})();
